export enum AddonKeys {
   CorrectionCulprit = 'correction-culprit',
   ETM = 'etm',
   Easypay = 'easypay',
   HarryInterface = 'harry-interface',
   Imw = 'imw',
   LetsworkSwok = 'letswork-swok',
   SicknessNotification = 'sickness-notification',
   WizardEmployment = '2-1-2-employment',
   performanceCodeLimits = 'performance-limits',
   Benefits = 'benefits',
}
